import React from 'react';
import { ElfsightWidget } from 'react-elfsight-widget';

function Component() {
  return <
  
  ElfsightWidget widgetID="d80763f0-bbaa-48c9-bbdc-181507b1af55"
  
   />;
  
}
  
  export default Component;
  